// extracted by mini-css-extract-plugin
export var dateLabel = "_3e-0";
export var dateLabelError = "_3e-1";
export var fullWidth = "_3e-2";
export var smaller = "_3e-3";